import { NavLink } from "@mantine/core";
import { useEffect, useRef } from "react";
import * as Sentry from "@sentry/remix";

export function SentryBugButton() {
  const bugButton = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (!bugButton.current) return;
    const feedback = Sentry.getFeedback();
    feedback?.attachTo(bugButton.current, {
      formTitle: "Report a Bug!",
    });
  }, [bugButton]);

  return (
    <NavLink
      label="Report a bug"
      className="link-button"
      ref={bugButton}
      suppressHydrationWarning
    />
  );
}
